import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.Recruitment}`;

export async function getRecruitmentConfig(data) {
  return await Client.get(`${endpoint}/config/keys`, data, true);
}

export async function getApplyMy() {
  return await Client.get(`${endpoint}/apply/my`, {}, true);
}

export async function putApplyMy(data) {
  return await Client.put(`${endpoint}/apply/my`, data, true);
}

export async function uploadFileApplyMyFiles(image, onProgress = null) {
  return await Client.uploadFileWithoutCompress(`${endpoint}/apply/my/files`, 'image', image, onProgress);
}

export async function uploadFileApplyMyImages(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/apply/my/files`, 'image', image, onProgress);
}
